import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services/currency.service';

@Pipe({
  name: 'antiqryCurrency',
  standalone: true,
  pure: false // Pure: false to automatically update when active currency changes
})
export class AntiqryCurrencyPipe implements PipeTransform {
  constructor(private currencyService: CurrencyService) {}

  transform(
    value: number | string | null | undefined, 
    sourceCurrency?: string, 
    convertToActive: boolean = false
  ): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const num = typeof value === 'string' ? parseFloat(value.replace(/[^\d.-]/g, '')) : value;
    if (isNaN(num)) {
      return '';
    }

    return this.currencyService.format(num, sourceCurrency, convertToActive);
  }
}
